// MockBankPricingAdapter — simulates bank internal pricing feed
// Pattern follows src/services/kycVendors/screeningAdapter.js

import { mockPriceFeeds, mockBookContext, mockCbReference } from '../../data/lpMockData';

export class MockBankPricingAdapter {
  constructor() {
    this.name = 'mock-bank-pricing';
    this._prices = {};
    this._intervals = [];

    // Deep-copy initial prices
    for (const [pair, data] of Object.entries(mockPriceFeeds)) {
      this._prices[pair] = { ...data };
    }
  }

  isAvailable() {
    return true;
  }

  /**
   * Stream price ticks. Calls onTick({ pair, bid, ask, mid, timestamp, latencyMs })
   * at 1-3s intervals with random walk.
   * One pair (EUR/TZS) will go stale.
   * Returns unsubscribe function.
   */
  streamPrices(onTick) {
    // Emit current prices immediately
    for (const [pair, data] of Object.entries(this._prices)) {
      onTick({ pair, ...data });
    }

    const interval = setInterval(() => {
      for (const [pair, data] of Object.entries(this._prices)) {
        // EUR/TZS stays stale
        if (pair === 'EUR/TZS') continue;

        // Random walk: +-0.05% of mid
        const change = data.mid * (Math.random() - 0.5) * 0.001;
        data.mid = Math.round((data.mid + change) * 100) / 100;
        const spread = (data.ask - data.bid) || data.mid * 0.002;
        data.bid = Math.round((data.mid - spread / 2) * 100) / 100;
        data.ask = Math.round((data.mid + spread / 2) * 100) / 100;
        data.timestamp = Date.now();
        data.latencyMs = 20 + Math.floor(Math.random() * 80);

        onTick({ pair, ...data });
      }
    }, 1000 + Math.random() * 2000);

    this._intervals.push(interval);

    return () => {
      clearInterval(interval);
      this._intervals = this._intervals.filter(i => i !== interval);
    };
  }

  /**
   * Get the current book context (positions, NOP).
   */
  async getBookContext() {
    return { ...mockBookContext, positions: { ...mockBookContext.positions } };
  }

  /**
   * Get the current CBK reference rate.
   */
  async getCbReference() {
    return { ...mockCbReference, rates: { ...mockCbReference.rates } };
  }

  /**
   * Cleanup intervals.
   */
  destroy() {
    this._intervals.forEach(i => clearInterval(i));
    this._intervals = [];
  }
}
